import { reactive } from 'vue'

export const store = {
    debug: true,
  
    state: reactive({
        addressToEdit: null,
        addressToSearch: null,
        from: {
            road:  'Place du Capitole',
            zipCode: '31000',
            city: 'Toulouse',
            complement: null,
            country: null,
            state: null
        },
        to: {
            road: "Place de l'Hôtel de Ville",
            zipCode: '11000',
            city: 'Narbonne',
            complement: null,
            country: null,
            state: null
        },
        fields: [{
            name: 'road',
            label: 'Road',
            title: 'Road',
            type: 'text',
            style: {
            color: 'blue'
            }
        }, {
            name: 'zipCode',
            label: 'Zip Code',
            type: 'number'
        }, {
            name: 'city',
            label: 'City',
            type: 'text'
        }, {
            name: 'complement',
            label: 'Complement',
            type: 'text'
        }, {
            name: 'country',
            label: 'Country',
            type: 'text'
        }, {
            name: 'state',
            label: 'State',
            type: 'text'
        }],
        coordinates: null,
        loading: false,
        currentCoordinate: null
    }),
  
    async fetchCoordinates (address) {
        store.state.loading = true
        store.state.addressToEdit = 'info'
        // console.log('loading... :', this.loading)
        try {
          const response = await fetch(
            'https://api-adresse.data.gouv.fr/search/?q=' +
            address.road + ' ' + address.zipCode + ' ' + address.city + ' '
          )
  
          const json = await response.json()
          json.features.forEach(currentFeature => {
            currentFeature.geometry.coordinates.reverse()
          })
          store.state.coordinates = json.features
        } catch {
          // do nothing
        }
        store.state.loading = false
    }
}